import React from 'react';

import ButtonIcon from './button-icon';
import CartPreview from '../../../utility/components/cart-preview/cart-preview';

import './header-cart.less';

/** Presentational compotent shared by desktop and mobile headers */
export function HeaderCart() {
    return (
        <div className="header-cart">
            <CartPreview stickyCart>
                {({ count, onHover, onClick, isNewVersion, showPreview }) => {
                    return (
                        <React.Fragment>
                            {count && (
                                <span className="cart-badge-container">
                                    <span className="cart-badge">{count}</span>
                                </span>
                            )}
                            <ButtonIcon
                                onClick={onClick}
                                buttonClass={`${isNewVersion ? ' new-version' : ''}${
                                    showPreview ? ' minicart-open' : ''
                                }`}
                                onMouseEnter={onHover}
                                icon="icon-cart"
                                ariaLabel="Shopping Cart"
                            />
                        </React.Fragment>
                    );
                }}
            </CartPreview>
        </div>
    );
}
export default HeaderCart;
